import {
  FETCH_MONTHLY_REPORT_FAILURE,
  FETCH_MONTHLY_REPORT_REQUEST,
  FETCH_MONTHLY_REPORT_SUCCESS,
} from "./monthlyReportActionTypes";

const initialState = {
  monthlyData: [],
  total: 0,
  totalSale:0,
  totalPurchase:0,
  loading: false,
  error: null,
};

const monthlyReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MONTHLY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_MONTHLY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        monthlyData: action.payload.data || [],
        total: action.payload.total,
        totalSale:action.payload.totalSale,
        totalPurchase:action.payload.totalPurchase
      };
    case FETCH_MONTHLY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        monthlyData: []
      };
    default:
      return state;
  }
};

export default monthlyReportReducer;